import { Directive, HostListener, OnDestroy } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';

@Directive({
  selector: '[appDomChange]',
})
export class DomChangeDirective implements OnDestroy {
  private changes: MutationObserver;

  // @Output()
  // public appDomChange = new EventEmitter();

  constructor(
    /* private elementRef: ElementRef, */ private authSrv: AuthService
  ) {
    /* const element = this.elementRef.nativeElement;

    this.changes = new MutationObserver((mutations: MutationRecord[]) => {
      mutations.forEach((mutation: MutationRecord) =>
        this.appDomChange.emit(mutation)
      );
    });

    this.changes.observe(element, {
      attributes: true,
      childList: true,
      characterData: true
    }); */
  }

  @HostListener('window:click', ['$event.toElement'])
  handleClick(el: HTMLElement) {
    if (!el) {
      return;
    }
    if (el.id !== 'refreshToken') {
      this.authSrv.refresh();
    }
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
  }
}
